import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitLawyerPayments } from './hooks'
import { TableLawyerPayments } from './TableLawyerPayments'
import { FormLawyerPayments } from './FormLawyerPayments'
import { InfoLawyerPayments } from './InfoLawyerPayments'

import { ArrowLeft } from 'react-feather';

export const LawyerPayments = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitLawyerPayments({location, paramsURL})

    const {
        globalStates,
        Actions
    } = useFetchInit

    const { showForm, rejectPayment } = globalStates
    const { handleClickShowForm, handleClickReturnToVehicleReception } = Actions

    return (
        <AllowedAccess permissions={['221_PROCESOS']} renderAuthFailed={<p>Error</p>}>
            
            {(!showForm) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <Button
                                    startIcon={<ArrowLeft/>}
                                    variant='text'
                                    color='error'
                                    size='large'
                                    sx={{ marginTop: 2, marginBottom : 2 }}
                                    onClick={handleClickReturnToVehicleReception}
                                >
                                    Volver a la pantalla anterior
                                </Button>
                                <div className="border-bottom border-dark"></div>
                                
                                <div className='h4 mt-1 mb-1'> Pagos por Abogacía & Notariado</div>
                                <div className="d-flex justify-content-end pt-4">
                                    <Button 
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type="button"
                                        disabled={rejectPayment}
                                        onClick={() => handleClickShowForm(true)}
                                    >
                                        <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                    </Button>
                                </div>
                                <InfoLawyerPayments useFetchInit={useFetchInit} />
                                <div className="pt-4"></div>
                                <TableLawyerPayments useFetchInit={useFetchInit} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {(showForm) && (
                <FormLawyerPayments useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}
